import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@root/rootReducer";

export const getAuthState = (state: RootState) => {
  return state.auth;
};

export const getAccessToken = createSelector(
  [getAuthState],(authState) =>{return authState.accessToken;}
)
export const getRefreshToken = createSelector(
  [getAuthState],(authState) =>{return authState.refreshToken;}
)
export const getTokenExpires = createSelector(
  [getAuthState],(authState) =>{return authState.tokenExpires;}
)
export const getUser = createSelector(
  [getAuthState],(authState) =>{return authState.user;}
)
export const getApiversion = createSelector(
  [getAuthState],(authState) =>{return authState.apiversion;}
)
